import React from "react";
import { FaSearch, FaUserPlus, FaTimes } from "react-icons/fa";
import ChatItem from "./ChatItem";

export default function ChatComponent({
  chats = [],
  changeSelected,
  load,
  loading,
  selected,
}) {
  const [active, setactive] = React.useState(false);
  const [searchValue, setsearchValue] = React.useState("");
  const [showSearch, setShowSearch] = React.useState(false);

  const toggleSearch = () => {
    if (!searchValue) setShowSearch(!showSearch);
  };

  const displayChats = chats.filter(
    (chat) =>
      chat.names?.toLowerCase().includes(searchValue?.toLowerCase()) ||
      chat.username?.toLowerCase().includes(searchValue?.toLowerCase())
  );

  return (
    <div className="chat-panel border mt-4 py-2 pl-2 pr-0">
      <div
        className="flex justify-between items-center m-2 pr-2"
        onBlur={toggleSearch}
      >
        <span
          className={`font-weight-bold ml-3 ${
            showSearch ? "text-sm" : "text-lg"
          }`}
        >
          Talk to a homie🔥
        </span>
        {showSearch && (
          <input
            className="searchMessage-input p-2 rounded"
            value={searchValue}
            onChange={(e) => setsearchValue(e.target.value)}
            placeholder="Search here"
          ></input>
        )}
        {toggleSearch ? 
      <FaSearch
      className="text-lg cursor-pointer"
      onClick={toggleSearch}
    ></FaSearch> :
    <FaTimes
          className="text-lg cursor-pointer"
          onClick={toggleSearch}
        ></FaTimes>


      }
        
        
        
      </div>

      <div className="chat-buttons mx-2 mt-3 flex justify-around pr-2">
        <button
          className={active ? "" : "active"}
          onClick={() => setactive(false)}
        >
          Recent Message
        </button>
        <button
          className={active ? "active" : ""}
          onClick={() => setactive(true)}
        >
          Active
        </button>
      </div>

      <div className="chat-list mt-4 pr-1">
        {displayChats.map((chat) => (
          <ChatItem
            chat={chat}
            key={chat._id}
            changeSelected={changeSelected}
            load={load}
            selected={selected}
          ></ChatItem>
        ))}
        {displayChats.length === 0 && (
          <div className="text-center mt-12">
            {loading ? "Loading..." : "No chats available to display."}
          </div>
        )}
        <div className="chat-add hover:opacity-50 hover:text-white">
          <FaUserPlus className="text-xl text-white"></FaUserPlus>
        </div>
      </div>
    </div>
  );
}
